import React from 'react';
import NavButtonsResponsive from './NavButtonsResponsive';
import '../Styles/Footer.css';

export default function Footer() {
  return (
    <footer className="responsive-footer">
      <NavButtonsResponsive />
    </footer>
  );
}
